import { createRoot } from "react-dom/client";
import { DragImage } from "@components/atoms/drag-image/drag-image";
import React from "react";
import { OurNode } from "@src/cloud-connect/poc/our-node";

export const setupDragImageOurNode = (
  e,
  firstNode: OurNode,
  amountOfSelectedNodes: number,
  typeOfDrag: string,
) => {
  const dragImageContainer = document.createElement("div");
  dragImageContainer.style.position = "absolute";
  dragImageContainer.style.top = "-1000px";
  document.body.appendChild(dragImageContainer);

  const nameOfFirstNode = firstNode.name;
  const typeOfFirstNode = firstNode.node_type;

  const root = createRoot(dragImageContainer);
  root.render(
    <DragImage
      count={amountOfSelectedNodes}
      text={nameOfFirstNode}
      icon={typeOfFirstNode}
    />,
  );
  e.dataTransfer.setData("text/plain", typeOfDrag);
  e.dataTransfer.setDragImage(dragImageContainer, 120.5, 20);

  setTimeout(() => {
    root.unmount();
    document.body.removeChild(dragImageContainer);
  }, 0);
};
